import React from "react";
import { Box, Chip, Tooltip } from "@mui/material";
import { textColorHandler } from "../Helpers";

export interface FilterChipsProps {
  searchTerm: string;
  activeFilters: { labels: string[]; types: string[] };
  labelOptions: { id: string; name: string }[];
  typeOptions: { id: string; name: string }[];
  onDeleteSearch: () => void;
  onDeleteFilter: (filterType: "labels" | "types", id: string) => void;
}

const FilterChips: React.FC<FilterChipsProps> = ({
  searchTerm,
  activeFilters,
  labelOptions,
  typeOptions,
  onDeleteSearch,
  onDeleteFilter,
}) => {
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      gap={0.5}
      alignItems="center"
      sx={{ overflowX: 'auto', whiteSpace: 'nowrap', py: 0.5 }}
    >
      {searchTerm && (
        <Chip
          size="small"
          color="primary"
          label={searchTerm}
          onDelete={onDeleteSearch}
          sx={{ height: 24, maxWidth: 80, fontSize: '0.7rem', px: 0.5 }}
        />
      )}
      {activeFilters.labels.map((id) => {
        const label = labelOptions.find((l) => l.id === id)?.name || 'N/A';
        const color = labelOptions.find((l) => l.id === id)?.color || '#2196f3';

        return (
          <Tooltip title={label} key={`tooltip-${id}`}>
            <Chip
              key={id}
              size="small"
              label={label}
              onDelete={() => onDeleteFilter("labels", id)}
              sx={{ 
                  height: 24, 
                  maxWidth: 80,
                  fontSize: '0.7rem', 
                  px: 0.5,
                  backgroundColor: `${color} !important`,
                  color: `${textColorHandler(color)} !important`,
              }}
            />
          </Tooltip>
        );
      })}
      {activeFilters.types.map((id) => {
        const type = typeOptions.find((t) => t.id === id)?.name || id;
        
        return (
          <Tooltip title={type} key={`tooltip-${id}`}>
            <Chip
              key={id}
              size="small"
              color="secondary"
              label={type}
              onDelete={() => onDeleteFilter("types", id)}
              sx={{ height: 24, maxWidth: 80, fontSize: '0.7rem', px: 0.5 }}
            />
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default FilterChips;